// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.loading_overlay {
    position: absolute;
    inset: 0;
    z-index: 500;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
}

.loading_overlay__spinner {
    display: block;
    width: 28px;
    height: 28px;
    border: 2px solid var(--color-border);
    border-top-color: var(--color-accent);
    border-radius: 50%;
    animation: loading_overlay_spin 0.7s linear infinite;
}

@keyframes loading_overlay_spin {
    to { transform: rotate(360deg); }
}
`, "",{"version":3,"sources":["webpack://./components/LoadingOverlay/s.loading_overlay.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,QAAQ;IACR,YAAY;IACZ,oCAAoC;IACpC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,cAAc;IACd,WAAW;IACX,YAAY;IACZ,qCAAqC;IACrC,qCAAqC;IACrC,kBAAkB;IAClB,oDAAoD;AACxD;;AAEA;IACI,KAAK,yBAAyB,EAAE;AACpC","sourcesContent":[".loading_overlay {\n    position: absolute;\n    inset: 0;\n    z-index: 500;\n    background-color: rgba(0, 0, 0, 0.5);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.loading_overlay__spinner {\n    display: block;\n    width: 28px;\n    height: 28px;\n    border: 2px solid var(--color-border);\n    border-top-color: var(--color-accent);\n    border-radius: 50%;\n    animation: loading_overlay_spin 0.7s linear infinite;\n}\n\n@keyframes loading_overlay_spin {\n    to { transform: rotate(360deg); }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
